import Vue from 'vue'
import VueI18n from 'vue-i18n'
import IdoniaLocales from './locales'

Vue.use(VueI18n)

export function loadLocaleMessages () {
  const messages = {}
  IdoniaLocales.locales.forEach(item => {
    messages[item.code] = require(`@/locales/${item.code}.json`)
  })
  return messages
}
export function getNewVueI18n (messages) {
  return new VueI18n({
    locale: IdoniaLocales.defaultLocale.code, // set locale
    fallbackLocale: IdoniaLocales.defaultLocale.code, // set fallback locale
    messages: messages
  })
}

const i18n = getNewVueI18n(loadLocaleMessages())

export default i18n

export function getI18n () {
  return i18n
}
